// A PARTNER által választható jegytípusok — EGY forrás a szűrőnek és a jegy-nyitónak.
//
// Az értékkészlet a `@atlas/contracts` `PortalTicketTypeSchema`-jából származik (ugyanaz, mint a belső
// jegy-szerződésben, mert ugyanabba az `support/tickets` erőforrásba írunk). A FELIRAT i18n-ből jön
// (`portal.type.*`), ezért itt csak a kulcsok vannak — így egy új típus egyetlen helyen kerül be.
import { PortalTicketStatusSchema, PortalTicketTypeSchema } from '@atlas/contracts';

export const PORTAL_TICKET_TYPES = PortalTicketTypeSchema.options;
export type PortalTicketTypeKey = (typeof PORTAL_TICKET_TYPES)[number];

/**
 * A STÁTUSZ-szűrő értékkészlete — ugyanabból a szerződésből (`PortalTicketStatusSchema`). A partner-listán
 * nincs státusz-OSZLOP (a jelvény a sor első oszlopában áll), ezért a szűkítést ez adja; a FÜL (folyamatban /
 * lezárt) marad a durva bontás, tehát a két szűrő szándékosan adhat üres listát együtt.
 */
export const PORTAL_TICKET_STATUSES = PortalTicketStatusSchema.options;
export type PortalTicketStatusKey = (typeof PORTAL_TICKET_STATUSES)[number];
